// MUIDataTable `columnOrder` that DISPLAYS the date column(s) right before the
// (pinned) actions column without moving the underlying rowData indices.
// `dateNames` is one name or an array; they end up in the given order, just
// before `actionsName`. Unknown names leave the natural order untouched.
export const columnOrderDateBeforeActions = (columns, dateNames, actionsName) => {
  let order = columns.map((c, i) => i);
  const actionsIndex = columns.findIndex((c) => c.name === actionsName);
  if (actionsIndex === -1) return order;
  [].concat(dateNames).forEach((name) => {
    const dateIndex = columns.findIndex((c) => c.name === name);
    if (dateIndex === -1) return;
    order = order.filter((i) => i !== dateIndex);
    order.splice(order.indexOf(actionsIndex), 0, dateIndex);
  });
  return order;
};
